import { createFileRoute } from "@tanstack/react-router";

import { PermissionGuard } from "@/components/shared/guards/permission-guard";
import { TenantAdminPage } from "@/features/tenant-admin";

/** Tenant-scoped administration surfaces are individually permissioned. */
function TenantAdminRoute() {
  return (
    <PermissionGuard module={["tenant_admin", "subscription"]}>
      <TenantAdminPage />
    </PermissionGuard>
  );
}

export const Route = createFileRoute("/tenant-admin/")({
  component: TenantAdminRoute,
});
